module.exports = __webpack_public_path__ + "img/edit.a0a8ee0d.png";